import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IScheduleListDto } from '../../lib/repository/schedule/schedule.model';
import { StateItem } from '../../lib/state-item';

@Injectable()
export class PickupTargetStateItem extends StateItem<IScheduleListDto[]> {
  // 요약: 미배정
  private unassigned: number = 0;

  // 요약: 배정
  private assigned: number = 0;

  constructor() {
    super([]);
  }

  // 값 설정 시 요약도 같이 계산
  protected override setValue(newValue: IScheduleListDto[]): void {
    // 요약: 배정
    this.assigned = 0;
    // 요약: 미배정
    this.unassigned = 0;

    // 요약 설정
    newValue.forEach(({ pickupAssignFlg }: IScheduleListDto) => {
      if (pickupAssignFlg) {
        this.assigned += 1;
      } else {
        this.unassigned += 1;
      }
    });

    // 값 설정
    super.setValue(newValue);
  }

  // 목록 설정
  setList(list: IScheduleListDto[]): void {
    this.setValue(list);
  }

  get list$(): Observable<IScheduleListDto[]> {
    return this.value$;
  }

  get list(): IScheduleListDto[] {
    return this.value;
  }

  // 배정된 수
  get assignedNumber(): number {
    return this.assigned;
  }

  // 배정되지 않은 수
  get unassingedNumber(): number {
    return this.unassigned;
  }

  // 전체
  get totalNumber(): number {
    return this.list.length;
  }
}
